<template>
  <div class="commissions campaign-step">
    <div class="step-header">
      <div class="step-icon">
        <img src="/images/percent.svg" alt="Комиссии" />
      </div>
      <h2>{{ $t('messages.commissions') }}</h2>
    </div>

    <div class="settings-content">
      <div class="form-group">
        <label class="form-label">{{ $t('messages.commissions') }}</label>
        <div class="commission-single">
          <input type="number" class="form-input" :value="commission" disabled />
          <span class="percentage-symbol">%</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Commissions",
  props: {
    campaign: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      commission: 20
    };
  },
  mounted() {
    this.commission = this.resolveCommission(this.campaign);
  },
  watch: {
    campaign: {
      handler(newCampaign) {
        this.commission = this.resolveCommission(newCampaign);
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    resolveCommission(campaign) {
      const value = campaign?.commissions;
      return value !== undefined && value !== null ? Number(value) : 20;
    }
  }
};
</script>

<style lang="scss" scoped>
.commissions {
  max-width: 400px;

  .commission-single {
    position: relative;
    width: 200px;
  }

  .percentage-symbol {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: #495057;
    pointer-events: none;
  }
}
</style>

